import axios from 'axios';

const axiosInstance = axios.create({
  // for cloud
 baseURL: 'https://anlyeng.smartler.in/',  
  // for WFH
 //baseURL: 'http://13.234.144.120:8096/', 
  // for alpha site
 //baseURL: 'http://192.168.82.1:8096/', 


// baseURL: 'http://111.93.227.213:8096/', 
 //baseURL: 'http://192.168.82.2:8096/'
  //baseURL: 'http://3.111.207.158:8096/', 
});


// Add the access token to the request headers
axiosInstance.interceptors.request.use(
  (config) => {
    // Get the access token from localStorage
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    console.log(refreshToken,"refreshToken 00")
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// new one
let refreshTokenPromise = null;

// Function to handle token refresh
async function refreshTokenHandler(originalRequest) {
  if (!refreshTokenPromise) {
    const refreshToken = localStorage.getItem('refreshToken');
    console.log(refreshToken,"refreshToken 1")
    refreshTokenPromise = axios.get(
      'https://anlyeng.smartler.in/auth/generate-access-token', // GET request
      {
        headers: {
          'Authorization': `Bearer ${refreshToken}` // Send refreshToken as Bearer
        }
      }
    )
      .then(response => {
        if (response.status === 200) {
          console.log("response", response)
          const { accessToken, refreshToken } = response.data.data;
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', refreshToken);
          console.log(accessToken,"accessToken 1")
          console.log(refreshToken,"refreshToken 2")
          refreshTokenPromise = null;
          return accessToken;
        } else {
          throw new Error("Invalid refresh token response");
        }
      })
      .catch(error => {
        refreshTokenPromise = null;
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(error);
      });
  }

  return refreshTokenPromise.then(newToken => {
    originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
    return axiosInstance(originalRequest);
  });
}

// Response interceptor: Handle token expiration
axiosInstance.interceptors.response.use(
  response => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      return refreshTokenHandler(originalRequest);
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
